/** QuickHouse — Ruban d'outils (type Word/Excel) : groupes de boutons icône + libellé.
 *  Les options contextuelles de l'outil actif restent dans le panneau de gauche. */
import { useProjectStore } from '../store/useProjectStore.js';

const GROUPS = [
  {
    label: 'Édition',
    tools: [
      { action: 'undo', icon: '↶', label: 'Annuler', title: 'Annuler (Ctrl+Z)' },
      { action: 'redo', icon: '↷', label: 'Refaire', title: 'Refaire (Ctrl+Y)' },
      { id: 'select', icon: '🖱', label: 'Sélection', key: 'S' },
      { id: 'delete', icon: '🗑', label: 'Supprimer', key: 'X' },
    ],
  },
  {
    label: 'Construction',
    tools: [
      { id: 'wall', icon: '🧱', label: 'Mur', key: 'W' },
      { id: 'room', icon: '◻', label: 'Pièce', key: 'T' },
      { id: 'slab', icon: '▦', label: 'Dalle', key: 'D' },
      { id: 'roof', icon: '⛰', label: 'Toit', key: 'C' },
      { id: 'stair', icon: '🪜', label: 'Escalier', key: 'E' },
      { id: 'beam', icon: '🪵', label: 'Poutre', key: 'U', title: 'Charpente : poutres, linteaux, pannes, poteaux — pergolas et tonnelles (U)' },
    ],
  },
  {
    label: 'Menuiseries',
    tools: [
      { id: 'door', icon: '🚪', label: 'Porte', key: 'P' },
      { id: 'window', icon: '🪟', label: 'Fenêtre', key: 'F' },
      { id: 'garage', icon: '🚗', label: 'Garage', key: 'G' },
      { id: 'passage', icon: '▢', label: 'Ouverture', key: 'O' },
    ],
  },
  {
    label: 'Bibliothèque',
    tools: [
      { id: 'item', icon: '📦', label: 'Objet', key: 'B' },
    ],
  },
  {
    label: 'Mesure',
    tools: [
      { id: 'measure', icon: '📏', label: 'Cote', key: 'M', title: 'Cote entre deux points (M) — persistée sur le plan' },
    ],
  },
  {
    label: 'Repère',
    tools: [
      { id: 'origin', icon: '⌖', label: 'Origine', title: 'Redéfinir l\'origine (0,0) du projet : cliquez un point (accroché aux coins) — tout le plan est recalé sur ce repère' },
    ],
  },
];

export default function Ribbon() {
  const tool = useProjectStore((s) => s.tool);
  const setTool = useProjectStore((s) => s.setTool);
  const undo = useProjectStore((s) => s.undo);
  const redo = useProjectStore((s) => s.redo);
  const canUndo = useProjectStore((s) => s.past.length > 0);
  const canRedo = useProjectStore((s) => s.future.length > 0);
  const chatBusy = useProjectStore((s) => s.chatBusy);

  const onClick = (t) => {
    if (t.action === 'undo') return undo();
    if (t.action === 'redo') return redo();
    return setTool(t.id);
  };
  const isDisabled = (t) => chatBusy
    || (t.action === 'undo' && !canUndo)
    || (t.action === 'redo' && !canRedo);

  return (
    <div className="ribbon">
      {GROUPS.map((g) => (
        <div key={g.label} className="ribbon-group">
          <div className="ribbon-tools">
            {g.tools.map((t) => (
              <button
                key={t.action ?? t.id}
                className={`ribbon-btn ${t.id && tool === t.id ? 'active' : ''}`}
                disabled={isDisabled(t)}
                onClick={() => onClick(t)}
                title={t.title ?? `${t.label}${t.key ? ` (${t.key})` : ''}`}
              >
                <span className="ribbon-icon">{t.icon}</span>
                <span className="ribbon-label">{t.label}</span>
              </button>
            ))}
          </div>
          <div className="ribbon-group-label">{g.label}</div>
        </div>
      ))}
    </div>
  );
}
